import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "saveButton", "cancelButton", "reviewButton"]

  initialize () { 
    let _this = this,
        form_changed = false;

    this.visitHandler = (event) => leavingPage(event)
    window.addEventListener('beforeunload', this.visitHandler)
    document.addEventListener('turbo:before-visit', this.visitHandler)

    if (_this.hasFormTarget && _this.hasSaveButtonTarget && _this.hasCancelButtonTarget) { 
      let form = _this.formTarget;

      form.addEventListener("input", function () {
        form_changed = true;
        _this.saveButtonTarget.classList.remove('hidden');

        if (_this.hasReviewButtonTarget)
          _this.reviewButtonTarget.classList.add("hidden");

      });

      form.addEventListener("turbo:submit-start", function (event) { 
        window.onbeforeunload = null;
      });

      _this.saveButtonTarget.addEventListener("click", function() {
        form_changed = false;
      });

      _this.cancelButtonTarget.addEventListener("click", function() {
        form_changed = false;
        document.getElementById("back_button").click();
      });

    }

    function leavingPage(event) {
      if (event.type == 'beforeunload')
        window.onbeforeunload = null;

      console.log(event.type, form_changed);

      if (form_changed && !window.confirm('Leave site? Changes that you made may not be saved.')) {
        event.preventDefault();
        
      }
    }

  }

  disconnect() {
    window.removeEventListener('beforeunload', this.visitHandler)
    document.removeEventListener('turbo:before-visit', this.visitHandler)
  }

  

}